import { $themeConfig } from '@themeConfig';
import useJwt from '@/auth/jwt/useJwt';
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue';
import router from '../../router';
import app from '@/main';
export default {
  namespaced: true,
  state: {},
  getters: {},
  mutations: {},
  actions: {
    upFile({ commit }, payload) {
      return new Promise((resolve, reject) => {
        useJwt
          .put('attachFile', payload)
          .then(response => {
            resolve(true);
          })
          .catch(error => {
            resolve(false);
          });
      });
    },
    deleteFile({ commit }, data) {
      return new Promise((resolve, reject) => {
        useJwt
          .put('deleteAttachFile',  data)
          .then(response => {
            resolve(true);
          })
          .catch(error => {
            resolve(false);
          });
      });
    },

    viewFile({ commit }, { id, name }) {
      return new Promise((resolve, reject) => {
        useJwt
          .get('previewFile', { params: { id, name } })
          .then(response => {
            resolve(response);
          })
          .catch(error => {
            resolve(false);
          });
      });
    },
  },
};
